
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useForm } from "@/context/FormContext";
import { FormFieldType } from "@/types/form";
import FieldWrapper from "./FieldWrapper";
import { useTranslation } from "react-i18next";
import { tField } from "../utils/i18nField";

interface SelectFieldProps {
  element: FormFieldType;
}

export const SelectField: React.FC<SelectFieldProps> = ({ element }) => {
  const { formData, setField } = useForm();
  const { t } = useTranslation();
  
  const handleChange = (value: string) => {
    setField(element.name!, value);
  };

  if (!element.options) return null;

  return (
    <FieldWrapper element={element}>
      <Select
        value={(formData[element.name!] as string) || ""}
        onValueChange={handleChange}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder={tField(t, element.placeholder) || "Select an option"} />
        </SelectTrigger>
        <SelectContent>
          {element.options.map((option) => (
            <SelectItem
              key={option.value.toString()}
              value={option.value.toString()}
            >
              {tField(t, option.label)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FieldWrapper>
  );
};

export default SelectField;
